import React, { useMemo } from "react";

const useGetAgentName = () => {
  const hostname = window.location.hostname.split(".")[0];
  const expectedName = [
    "911win",
    "new911snd",
    "new911viet",
    "www",
    "127",
    "localhost",
  ];
  const isExpectedName = useMemo(() => {
    if (expectedName.includes(hostname)) {
      return "";
    } else {
      return hostname;
    }
  }, [hostname]);
  return isExpectedName;
};

export default useGetAgentName;
